import { useLazySearchCompanyQuery } from '../api/eecs-company.api';
import { IEecsCompany, ISearchCompanyPayload } from '../types/eecs-company.type';

interface UseEecsCompany {
  searchEecsCompanyQueryHandler: (payload: ISearchCompanyPayload) => Promise<IEecsCompany[]>;
}

export const useEecsCompany = (): UseEecsCompany => {
  const [searchCompanyQuery] = useLazySearchCompanyQuery();
  const searchEecsCompanyQueryHandler = async (payload: ISearchCompanyPayload) => {
    const { isError, data: response } = await searchCompanyQuery(payload);
    if (isError || !response?.data) return [];
    return response.data;
  };

  return {
    searchEecsCompanyQueryHandler,
  };
};
